// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import { CardContentProps } from '../CardContentType';
import RouteBuilder from '@Services/RouteBuilder';
import StreamCard from '@Organisms/LiveStreamData/StreamCard/StreamCard';
import { PropRender } from '@Organisms/LiveStreamData/PropRenderer/PropRenderer';
import { ICONS } from '@Constants/iconsApp';

export const CaseContent = ({ data, base }: CardContentProps): ReactElement => {
    const { title, description, _id, tags } = data || {};

    const { action, details, object = {} } = base;

    const path = RouteBuilder.compute('cases.details', { caseId: _id });

    const titleCard =
        action === 'delete'
            ? `#${details?.number} - ${object?.title ?? details?.title}`
            : `#${object?.number ?? details?.number} - ${title ?? details?.title}`;

    const detailsCreated = {
        tags,
        description,
    };

    return (
        <StreamCard icon={<ICONS.CaseIcon />} title={titleCard} path={path} base={base}>
            {action === 'create' &&
                Object.entries(detailsCreated).map(([key, value]) => (
                    <PropRender key={_id + key} prop={key} value={value} type="case" />
                ))}

            {action === 'update' &&
                Object.entries(details).map(([key, value]) => (
                    <PropRender key={_id + key} prop={key} value={value} type="case" />
                ))}
        </StreamCard>
    );
};
